import { createSlice } from '@reduxjs/toolkit';
import { storeResources } from '../resources';
import { IConfigInitialState } from './types';
import { ThunkGetClientPortalTechnicianData, ThunkGetPortalConfig } from './thunks';
import { PsaTypes } from '../../services/config/types';

const initialState: IConfigInitialState = {
  config: {
    caption: '',
    logo: '',
    colorScheme: '#000' + '',
    psaType: 0,
    disableChats: false,
    defaultTicketTemplateName: '',
    useDefaultTicketTemplate: false,
    verificationTechType: '',
    useHelpdeskAi: false,
  },
  technicianData: {},
};

const configSlice = createSlice({
  name: storeResources.CONFIG,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(ThunkGetPortalConfig.fulfilled, (state, action) => {
      state.config = action.payload;
      localStorage.setItem('psa', PsaTypes[action.payload.psaType]);
    });

    builder.addCase(ThunkGetClientPortalTechnicianData.fulfilled, (state, action) => {
      state.technicianData = action.payload;
    });
  },
});

export default configSlice.reducer;
